

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-fi-logos.directive', ['squid']).directive('xoFiLogos', function () {

        return {
            template: template,
            scope: {
                token: '='
            },

            controller: function controller($scope, $populate, $locale, $CardTypesModel) {

                $populate($scope, {
                    cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
                        token: $scope.token,
                        country: $locale.country
                    })
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/fi-logos/directive.js
// module id = ./components/xo-wallet-components/src/fi-logos/directive.js
// module chunks = 1